import { FC, ReactNode, useEffect } from 'react'

import { createPortal } from 'react-dom'

import styles from './WidgetOverlay.module.scss'

interface WidgetOverlayProps {
  onClose?: () => void
  children: ReactNode
  ariaLabel?: string
}

export const WidgetOverlay: FC<WidgetOverlayProps> = ({
  onClose,
  children,
  ariaLabel
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation()
        onClose?.()
      }
    }
    document.addEventListener('keydown', onKey, true)
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey, true)
      document.body.style.overflow = prevOverflow
    }
  }, [onClose])

  return createPortal(
    <div
      className={styles.overlay}
      role='dialog'
      aria-modal='true'
      aria-label={ariaLabel}
      onClick={onClose}
    >
      <div className={styles.shell} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body
  )
}
